import skills from './data'
import './skills.css'

const Skills = () => {
  return (
    <section id="skills">
      <h2>My Skills</h2>
      <p>
        These are tools , frameworks and programming languages whom I am skilled
      </p>
      <div className="container skills__container" data-aos="fade-up">
        {
          skills.map(skills => <a key={skills.id} href={skills.link} target="_blank" rel="noopener noreferrer">{skills.icon}</a>)
        }
      </div>
    </section>
  )
}

export default Skills